
<div class="flow-history-card-wrapper">
	<h5 v-if="when" class="fc-light upper-case flow-history-card-when">
		{{ when }}
	</h5>
	<div class="display-flex flex-d-c flex-vertical-gap-16 flow-history-card" :selected="selected">
		<div class="display-flex flex-d-c">
			<div class="fc-dark display-flex align-items-center">
				<span>{{ date }}</span>
				<Tag v-if="tagType" class="margin-lt-auto" :type="tagType">
					{{ tagText }}
				</Tag>
			</div>
			<div class="fc-light paragraph-1">
				{{ duration }}
			</div>
			<div class="fc-light paragraph-1">
				<slot name="status" />
			</div>
			<div class="fc-light paragraph-1">
				{{ by }}
			</div>
		</div>
	</div>
	<Divider />
</div>
